var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 207,
    viewBox: "0 0 376 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17563_194798)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 368,
    height: 199,
    rx: 10,
    fill: "#004AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-134.238 12.3438L288.61 -18.8717C365.371 141.382 376.206 211.211 310.907 283.163L-111.942 314.379L-134.238 12.3438Z",
    fill: "url(#paint0_linear_17563_194798)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-185.363 -31L237.048 5.6606C287.252 176.11 286.806 246.773 210.862 307.383L-211.549 270.722L-185.363 -31Z",
    fill: "url(#paint1_linear_17563_194798)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-293 -11.3438L130.89 -20.946C199.375 143.016 206.634 213.306 137.749 281.833L-286.141 291.435L-293 -11.3438Z",
    fill: "url(#paint2_linear_17563_194798)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 153,
    width: 3,
    height: 7,
    rx: 1.5,
    fill: "#CCDBFD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 153,
    width: 3,
    height: 7,
    rx: 1.5,
    fill: "#CCDBFD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 153,
    width: 3,
    height: 7,
    rx: 1.5,
    fill: "#CCDBFD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 153,
    width: 3,
    height: 7,
    rx: 1.5,
    fill: "#CCDBFD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 153,
    width: 3,
    height: 7,
    rx: 1.5,
    fill: "#CCDBFD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299,
    y: 153,
    width: 3,
    height: 7,
    rx: 1.5,
    fill: "#CCDBFD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 153,
    width: 3,
    height: 7,
    rx: 1.5,
    fill: "#CCDBFD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309,
    y: 153,
    width: 3,
    height: 7,
    rx: 1.5,
    fill: "#CCDBFD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 153,
    width: 3,
    height: 7,
    rx: 1.5,
    fill: "#CCDBFD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319,
    y: 153,
    width: 3,
    height: 7,
    rx: 1.5,
    fill: "#CCDBFD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 153,
    width: 3,
    height: 7,
    rx: 1.5,
    fill: "#CCDBFD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329,
    y: 153,
    width: 3,
    height: 7,
    rx: 1.5,
    fill: "#CCDBFD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 153,
    width: 3,
    height: 7,
    rx: 1.5,
    fill: "#CCDBFD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339,
    y: 153,
    width: 3,
    height: 7,
    rx: 1.5,
    fill: "#CCDBFD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.105,
    y: -66,
    width: 69,
    height: 58,
    rx: 5,
    transform: "rotate(32.4316 174.105 -66)",
    fill: "#FCBF23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.105,
    y: 188,
    width: 69,
    height: 58,
    rx: 5,
    transform: "rotate(32.4316 174.105 188)",
    fill: "#FCBF23"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 372,
    height: 203,
    rx: 12,
    stroke: "#1464F4",
    strokeOpacity: 0.15,
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17563_194798",
    x1: -354.765,
    y1: 192.611,
    x2: 872.287,
    y2: 71.6597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004AF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0030A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17563_194798",
    x1: -431.83,
    y1: 111.767,
    x2: 798.799,
    y2: 188.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004AF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0030A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17563_194798",
    x1: -522.436,
    y1: 157.438,
    x2: 709.188,
    y2: 99.2451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004AF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0030A0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17563_194798"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 368,
    height: 199,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletCard);
export default __webpack_public_path__ + "static/media/wallet-card.c8fa3b714cb0f66f590f831d993cbf27.svg";
export { ForwardRef as ReactComponent };